import type { FC } from 'react';
import React from 'react';

import Icon from '../../../../components/Icon';
import CurrencyFormat from '../../../../components/CurrencyFormat';

const baseCls = 'checkout-summary';

interface SummaryProps {
  instantConfirm?: boolean;
  value?: number;
  children?: React.ReactNode;
}

const Summary: FC<SummaryProps> = ({ children, instantConfirm, value = 0 }) => (
  <div className="flex flex-space-between">
    <div className="flex">
      {instantConfirm && (
        <Icon className={`${baseCls}__instant-confirm`} type="lightning" />
      )}
      <CurrencyFormat className={`${baseCls}__total`} value={value} />
    </div>
    {children}
  </div>
);

export default Summary;
